import {
  hasEditPlotRatingConfigRole,
  hasExperimentsRole,
} from "../../users/rolesUtil";

import { ButtonAddRemoveUser } from "../../components/ButtonAddRemoveUser";
import PropTypes from "prop-types";
import React from "react";
import { THEME } from "../../constants";
import { UploadCounter } from "./UploadCounter";
import chroma from "chroma-js";
import { formatPeriod } from "./format";

// A uniform card tile for a single campaign (contract info).
export const CampaignTile = ({
  campaign,
  actionsVisible,
  uploads,
  onOpen,
  onEditPlotRating,
  onOpenAdmin,
}) => {
  const accent = chroma(THEME.companyColorHash.hex(campaign.company.name))
    .darken(0.4)
    .hex();
  const stop = (event) => event.stopPropagation();

  return (
    <div
      className="cf-tile"
      style={{ "--cf-accent": accent }}
      role="button"
      tabIndex={0}
      onClick={() => onOpen(campaign)}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpen(campaign);
        }
      }}
    >
      <div className="cf-tile__actions" onClick={stop}>
        {hasEditPlotRatingConfigRole(campaign.roles) && (
          <button
            type="button"
            className="cf-iconbtn"
            data-tooltip-id="tooltip"
            data-tooltip-content="Plot rating configuration"
            onClick={() => onEditPlotRating(campaign)}
          >
            <i className="fa-solid fa-pencil" />
          </button>
        )}
        {actionsVisible && (
          <>
            <ButtonAddRemoveUser
              contract={campaign}
              company={campaign.company}
              hasContractAccess
              className="p-0"
            />
            <button
              type="button"
              className="cf-iconbtn"
              data-tooltip-id="tooltip"
              data-tooltip-content="Open in administration"
              onClick={() => onOpenAdmin(campaign)}
            >
              <i className="fa-solid fa-gears" />
            </button>
          </>
        )}
      </div>

      <div className="cf-tile__header">
        <span className="cf-tile__badge" title={campaign.company.name}>
          {campaign.company.name}
        </span>
        {campaign.has_experiment && hasExperimentsRole(campaign.roles) && (
          <i
            className="fa-solid fa-flask"
            style={{ color: accent, opacity: 0.7 }}
            data-tooltip-id="tooltip"
            data-tooltip-content="Field map enabled"
          />
        )}
      </div>

      <h3
        className="cf-tile__title"
        data-tooltip-id="tooltip"
        data-tooltip-content={campaign.name}
      >
        {campaign.name}
      </h3>
      <div className="cf-tile__subtitle">
        {formatPeriod(campaign.start_date, campaign.end_date)}
      </div>

      <div className="cf-tile__spacer" />

      <div className="cf-tile__footer">
        <div className="cf-metric">
          <span className="cf-metric__value">{campaign.total_sites ?? 0}</span>
          <span className="cf-metric__label">Sites</span>
        </div>
        {uploads && (
          <div style={{ marginLeft: "auto" }}>
            <UploadCounter counts={uploads} />
          </div>
        )}
      </div>
    </div>
  );
};

CampaignTile.propTypes = {
  campaign: PropTypes.object.isRequired,
  actionsVisible: PropTypes.bool,
  uploads: PropTypes.object,
  onOpen: PropTypes.func.isRequired,
  onEditPlotRating: PropTypes.func.isRequired,
  onOpenAdmin: PropTypes.func.isRequired,
};
